module.exports = __webpack_public_path__ + "files/835f239d9862fbb0352f60c65114a228.png";